/* global document */
import { useEffect } from 'react';

const HostedPaymentRedirectHiddenForm = (props) => {
  const { redirectObj } = props;
  const { url, postData } = redirectObj;
  useEffect(() => {
    document.getElementById('hostedPayment').submit();
  }, []);

  const postArray = Object.keys(postData);
  return (
    <form method="post" action={url} id="hostedPayment">
      {postArray.map((entity) => (
        <input
          type="hidden"
          key={entity}
          name={entity}
          value={postData[entity]}
        />
      ))}
    </form>
  );
};

export default HostedPaymentRedirectHiddenForm;
